const endpoints = {
    getTechTrends: "/details/operations",
    getWorkModes: "/details/workplace",
    getEducation: "/details/education",
    getMaps: "/details/country",
    getRoles: "/details/roles",
  };
  
  export default endpoints;
  